export default {"src":"/_next/static/media/vriendenloterij.ae1ec208.svg","height":292,"width":3129,"blurWidth":0,"blurHeight":0};